import { format } from 'date-fns';
import { findTimeZone, getUTCOffset } from 'timezone-support';

type TimeZoneInfo = ReturnType<typeof findTimeZone>;

// OE Java services run with -Duser.timezone=America/New_York, so their LocalDateTimes are NY wall time
export const SERVER_TIME_ZONE = 'America/New_York';

const MILLIS_PER_MINUTE = 60 * 1000;

export function dateArrayToDate(dateArray: number[]): Date | null {
  if (!dateArray || dateArray.length < 3) {
    return null;
  }
  const [year, month, day, hour = 0, minute = 0, second = 0, fraction = 0] = dateArray;
  return new Date(year, month - 1, day, hour, minute, second, fractionToMillis(fraction));
}

export function dateArrayToZonedDate(dateArray: number[], timeZone: string): Date | null {
  if (!dateArray || dateArray.length < 3) {
    return null;
  }
  const [year, month, day, hours = 0, minutes = 0, seconds = 0, fraction = 0] = dateArray;
  const zone = findTimeZone(timeZone);
  const wallMillis = Date.UTC(year, month - 1, day, hours, minutes, seconds, fractionToMillis(fraction));
  // Offset depends on the instant: guess it at the wall time, then read it again at the guess (DST change days)
  const guess = wallMillis + offsetMillis(wallMillis, zone);
  const millis = wallMillis + offsetMillis(guess, zone);
  return isNaN(millis) ? null : new Date(millis);
}

function offsetMillis(unixTime: number, zone: TimeZoneInfo): number {
  return getUTCOffset(unixTime, zone).offset * MILLIS_PER_MINUTE;
}

// Jackson sends the fraction as millis or nanos
function fractionToMillis(fraction: number): number {
  return fraction >= 1000 ? Math.floor(fraction / 1e6) : fraction;
}

export function dateArrayToString(dateArray: number[], stringFormat: string) {
  if (!dateArray || !dateArray.length || !stringFormat) {
    return '';
  }
  const date = dateArrayToDate(dateArray);
  if (!date) {
    return '';
  }
  return format(date, stringFormat);
}

export function dateToUnixTimeStampInSeconds(date: Date) {
  return Math.floor(date.getTime() / 1000);
}

export function milisecondsToUnixTimeStampInSeconds(miliseconds: number) {
  return dateToUnixTimeStampInSeconds(new Date(miliseconds));
}

export function getMinutesFromEpoch(epoch: number): number {
  const date = new Date(epoch);
  return date.getMinutes();
}

export function getMsToNextHalfHour(): number {
  const now = new Date();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  const milliseconds = now.getMilliseconds();

  if (minutes < 30) {
    return ((29 - minutes) * 60 * 1000) + ((59 - seconds) * 1000) + (999 - milliseconds);
  } else {
    return ((59 - minutes) * 60 * 1000) + ((59 - seconds) * 1000) + (999 - milliseconds);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/date-utils.ts